// extracted by mini-css-extract-plugin
module.exports = {"icon":"index_icon_2-469","carousel":"index_carousel_wV2I0"};